var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMe)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.handleRemove()}}},[_c('v-icon',{attrs:{"color":"error"}},[_vm._v("mdi-delete")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }